import React, { useEffect, useRef, useState } from "react";
/* eslint-disable import/no-unresolved */
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Navigation, EffectFade } from "swiper/modules";
import MapCard from "components/UiElement/Theme01/MapCard";
import {
  AlbumModal,
  ModalComponent,
  ReactGoogleMap,
} from "components/UiElement";
import { Button } from "react-bootstrap";

function LandmarkSection03({
  handleCloseMap,
  toggleClassMap,
  isActiveMap,
  locationList,
  leftPadding,
}) {
  const [center, setCenter] = useState({
    lat: parseFloat(locationList?.[0]?.lat),
    lng: parseFloat(locationList?.[0]?.long),
  });
  const swiper = useSwiper();
  const swiperRef = useRef(null);
  const [locId, setLocId] = useState(0);
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const options = { minZoom: 2, maxZoom: 6 };

  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const openImageModal = () => {
    setShowModal(!showModal);
  };

  const onHandleId = (id) => {
    setLocId(id);
    toggleClassMap();
  };

  const onHandleClose = () => {
    setShow(false);
    setDescription("");
  };

  useEffect(() => {
    if (locId) {
      let index = locationList.findIndex((item) => item?.id === locId);
      if (swiperRef.current && swiperRef?.current.swiper) {
        swiperRef.current.swiper.slideTo(index);
      }
    }
  }, [locationList, locId]);

  useEffect(() => {
    if (currentItem) {
      setCenter({
        lat: parseFloat(currentItem.lat),
        lng: parseFloat(currentItem.long),
      });
    }
  }, [currentItem]);

  return (
    <>
      <section
        className={`landmarkSec d-block justify-content-between position-relative ${
          isActiveMap ? "active" : ""
        }`}
      >
        <div
          className="landmarkSec_left py-80"
          style={{ paddingLeft: leftPadding }}
        >
          <div className="commonHead mb-0">
            <div className="commonHead_sub">
              Click an image to view a timeless memory
            </div>
            <h2 className="commonHead_title text-white">Lifetime Journey</h2>
          </div>
        </div>
        <div className="landmarkSec_right">
          <div className="mapOverlay" />
          <ReactGoogleMap
            position={center}
            options={options}
            zoom={0}
            isMarker
            customMarkerIcon="http://localhost:6011/public/uploads/image/album-photo/05-1693547521618--1--1711540092332.jpg"
            locationList={locationList}
            onHandleId={onHandleId}
          />

          <div className="landmarkSec_box">
            <Swiper
              spaceBetween={20}
              ref={swiperRef}
              slidesPerView={1}
              // loop
              centeredSlides
              pagination={{
                clickable: true,
              }}
              navigation={{
                nextEl: ".nextMap",
                prevEl: ".prevMap",
              }}
              modules={[Navigation, EffectFade]}
              effect="fade"
              onSlideChange={(e) => {
                setCurrentItem(locationList[e?.realIndex]);
              }}
            >
              {locationList?.length > 0 &&
                locationList?.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <MapCard
                        handleClose={handleCloseMap}
                        item={item}
                        index={index}
                        length={locationList?.length}
                        setShow={setShow}
                        setDescription={setDescription}
                        openImageModal={openImageModal}
                        setData={setData}
                        button={
                          <div className="flex-shrink-0 d-flex">
                            <div>
                              <Button
                                type="button"
                                className="btn me-2 me-lg-3 prevMap count_btn"
                                onClick={() => {
                                  if (swiper) swiper?.slidePrev();
                                }}
                              >
                                <em className="icon-arrow-right count_btn_arrowLeft" />
                              </Button>
                            </div>
                            <div>
                              <Button
                                type="button"
                                className="btn nextMap count_btn"
                                onClick={() => {
                                  if (swiper) swiper?.slideNext();
                                }}
                              >
                                <em className="icon-arrow-right" />
                              </Button>
                            </div>
                          </div>
                        }
                      />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
        <ModalComponent
          show={show}
          onHandleCancel={onHandleClose}
          title="Description"
          closeButton
          extraClassName="readMoreModal"
        >
          <div className="text-break">{description ? description : ""}</div>
        </ModalComponent>
      </section>
      <AlbumModal
        handleCloseModal={handleCloseModal}
        setData={setData}
        data={data}
        showModal={showModal}
      />
    </>
  );
}

export default LandmarkSection03;
